import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { inLastStep } from '../../selectors/ui';
import { toDecimals } from '../../helpers/currency';
import { getOrderTotal } from '../../selectors/cart';

class TikTok extends Component {

    constructor(props) {
        super(props);

        const { id: pixelId } = this.props.config || {};
        if (!pixelId) {
            return;
        }

        // subscribe to hooks
        this.props.addReservationCompleteHook(this.onReservationComplete);
        this.props.addTicketsAddedToCartHook(this.onTicketsAdded);
        this.props.addProductsAddedToCartHook(this.onProductsAdded);
        this.props.addBundlesAddedToCartHook(this.onBundlesAdded);
        this.props.addStateTransitionHook(this.onStateTransition);
    }

    render() {
        return null;
    }

    reportEvent = (type, args) => {
      this.props.reportEvent(type, {
        ...args,
        content_id: args.content_id ?? 'n/a'
      });
    }

    onReservationComplete = () => {
        const reservationSessionKey = 'TikTokPixel_onReservationComplete_' + this.props.confirmationNumber;
        const sent = sessionStorage.getItem(reservationSessionKey);
        if (sent) {
            return;
        }
        if (Array.isArray(this.props.payments) && this.props.payments.length) {
            const payment = this.props.payments[0];
            if (payment?.payment_method) {
                this.reportWholeReservationEvent('AddPaymentInfo', {
                    payment_type: payment.payment_method,
                });
            }
        }
        // It is mostly like a complete checkout event.
        this.reportWholeReservationEvent('SubmitForm', {
            content_id: this.props.confirmationNumber,
        });

        this.reportWholeReservationEvent('CompletePayment', {
            content_id: this.props.confirmationNumber,
        });

        sessionStorage.setItem(reservationSessionKey, '1');
    }


    // Inventory amount changes
    onTicketsAdded = tickets => {
        this.reportUpdateCartItemsEvent('AddToCart', 'ticket', tickets);
    }

    onProductsAdded = products => {
        this.reportUpdateCartItemsEvent('AddToCart', 'product', products);
    }

    onBundlesAdded = bundles => {
        this.reportUpdateCartItemsEvent('AddToCart', 'bundle', bundles);
    }

    reportUpdateCartItemsEvent = (eventType, itemType, items) => {
        this.reportEvent(eventType, {
            contents: [
                Object.assign(
                    ...items.map(item => this.formatItem(item, itemType)), { quantity: items?.length }
                )
            ],
            currency: this.props.currency || 'USD',
            value: this.getTotalCostOfItems(items),
        });
    }

    reportWholeReservationEvent = (eventType, extraFields = {}) => {
        this.reportEvent(eventType, {
            currency: this.props.currency,
            value: toDecimals({ amount: this.props.orderTotal, currency: this.props.currency }),
            items: this.formatAllReservationItems(),
            ...extraFields,
        });
    }

    formatAllReservationItems = () => {
        const items = [];
        this.props.tickets.forEach(ticket => {
            items.push(this.formatItem(ticket, 'ticket'));
        });
        this.props.productSales.forEach(product => {
            items.push(this.formatItem(product, 'product'));
        });
        this.props.bundleSales.forEach(bundle => {
            items.push(this.formatItem(bundle, 'bundle'));
        });
        return items;
    }

    onStateTransition = page => {
        // checkout step seen action
        if (typeof page === 'string' && page.startsWith('checkout-') && this.props.inLastStep) {
            this.reportWholeReservationEvent('InitiateCheckout');
        }
    }

    formatItem = (item, type) => {

        const itemIdFieldMap = {
            ticket: 'price_level_id',
            product: 'product_id',
            bundle: 'bundle_id',
        };

        const itemNameFieldMap = {
            ticket: 'price_level_name',
            product: 'product_name',
            bundle: 'name',
        };

        return {
            content_id: item?.[itemIdFieldMap[type]] + '',
            content_name: item?.[itemNameFieldMap[type]] + '',
            content_category: type,
            price: toDecimals({ amount: +item?.cost?.amount + +item?.buyer_fee?.amount, currency: this.props.currency }),
        };
    }

    getTotalCostOfItems = items => {
        let cost = 0;
        if (Array.isArray(items)) {
            items.forEach(item => {
                cost += +(item?.cost?.amount ?? 0);
                cost += +(item?.buyer_fee?.amount ?? 0);
            });
        }
        return toDecimals({ amount: cost, currency: this.props.currency });
    }
}

const mapStateToProps = state => {
    return {
        payments: state.payment.payments,
        confirmationNumber: state.reservation.confirmation_number,
        inLastStep: inLastStep(state),
        currency: state.reservation.currency || 'USD',
        orderTotal: getOrderTotal(state)?.amount ?? 0,
        tickets: state.tickets.tickets,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
        reservation: state.reservation
    }
}

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}

TikTok.propTypes = {
    config: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(TikTok)
